import { Box, Chip, IconButton, Popover, Tooltip, Typography } from "@mui/material";
import { Handle, Position, useReactFlow } from "reactflow";
import { i18n } from "../../../translate/i18n";
import { INode } from "../manager";
import { IconsConexaBot } from "../icons";
import { HandleConexaBot } from "../handle";
import classNames from "classnames";
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Theme } from '@mui/material/styles';
import { useState } from "react";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import MarkdownWrapper from "../../MarkdownWrapper";

const useStyles = makeStyles((theme: Theme) => createStyles({
  messageOptions: {
    width: 'fit-content',
    display: 'inline-block',
    borderRadius: '20px',
    marginTop: '2px',
    transition: 'opacity 0.3s ease',
    '& svg': {
      color: "#ffffff",
    },
  },
}));

export const EndNode = ({ data, onEdit, departments, conclusionMessages }: any) => {

  const classes = useStyles();
  const { id, label, type, subtype } = data as INode["data"];
  const [isHovered, setIsHovered] = useState(false);

  const { setNodes, setEdges } = useReactFlow();

  const handleDelete = () => {
    // remove node
    setNodes((nodes) => nodes.filter((n) => n.id !== id));
    // remove edges ligados a ele
    setEdges((edges) => edges.filter((e) => e.source !== id && e.target !== id));
  };

  const renderMessageOptions = () => {
    return (
      <Box
        className={classNames({
          [classes.messageOptions]: true,
        })}
        sx={{
          opacity: isHovered == true ? '1' : '0',
          position: "absolute",
          right: "10px"
        }}
      >
        <Tooltip
          title={i18n.t("buttons.edit")}
        >
          <IconButton
            size="small"
            onClick={(event) => onEdit(event, data)}
            id={`button-node-edit-${id}`}
            key={`button-node-edit-${id}`}
            sx={{
              width: "20px",
              height: "20px",
              backgroundColor: "#616161",
              right: "5px",
              "&:hover": {
                backgroundColor: "#616161",
              }
            }}
          >
            <EditOutlinedIcon />
          </IconButton>
        </Tooltip>

        <Tooltip
          title={i18n.t("buttons.delete")}
        >
          <IconButton
            size="small"
            onClick={handleDelete}
            id={`button-node-${id}`}
            key={`button-node-${id}`}
            sx={{
              background: (theme) => theme.palette.mode === "dark" ? "#f44336" : "#ef5350",
              width: "20px",
              height: "20px",
              "&:hover": {
                background: (theme) =>
                  theme.palette.mode === "dark" ? "#f44336" : "#ef5350",
              },
            }}
          >
            <DeleteOutlineOutlinedIcon
              sx={{
                fontSize: "12px"
              }}
            />
          </IconButton>
        </Tooltip>
      </Box>
    );
  }

  const filteredMessage = () => {
    let msg = data?.message || ""
    if (data?.subtype === "transfer" && departments && data?.departmentId) {
      const idx = departments.findIndex((dpt: any) => dpt.id == data.departmentId);
      if (idx >= 0) msg = `*Transferência: *${departments[idx]?.name}<br><br>` + msg;
    }

    if (data?.subtype === "finish" && conclusionMessages && data?.conclusionMessageId) {
      const idx = conclusionMessages.findIndex((cm: any) => cm.id == data.conclusionMessageId);
      if (idx >= 0) msg = `*Tabulação: *${conclusionMessages[idx]?.shortcut}<br><br>` + msg;
    }

    return msg;
  }

  return (
    <Box
      sx={{
        borderRadius: '3px',
        border: '1px solid',
        padding: '0px',
        width: 200,
        borderColor: '#757575',
        background: '#eeeeee',
        color: (theme) => theme.palette.mode == 'dark' ? '#757575' : '#424242',
        maxWidth: '400px',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onDoubleClick={(event) => onEdit(event, data)}
    >
      <Box
        sx={{
          background: "#545454",
          color: (theme) => theme.palette.mode === "dark" ? "#66bb6a" : "#ffffff",
          borderTopLeftRadius: "2px",
          borderTopRightRadius: "2px",
          padding: "5px",
          borderBottom: "1px solid #6B6B6B",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            fontSize: "0.75rem",
            "& svg": {
              width: 12,
              height: 12
            }
          }}
        >
          {IconsConexaBot[subtype]}
          {label}
          {renderMessageOptions()}
        </Box>

        <Typography
          component="p"
          sx={{
            fontSize: "0.45rem",
            marginTop: "2px",
            marginLeft: "20px",
            color: (theme) => theme.palette.mode == 'dark' ? '#757575' : '#bdbdbd',
          }}
        >
          {`${id} - ${i18n.t(`conexaBots.nodes.${type}.${subtype}`)}`}
        </Typography>
      </Box>

      <Typography
        component="p"
        sx={{
          fontSize: "0.5rem",
          padding: "5px 10px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          "& img": {
            width: "15px !important",
            height: "15px !important",
          }
        }}
      >
        <MarkdownWrapper>
          {filteredMessage()}
        </MarkdownWrapper>
      </Typography>
      <HandleConexaBot type="target" subtype={subtype} id={`${id}-target`} />
    </Box>
  )
};